import React from 'react'
import { Provider } from 'react-redux'
import ReactDOM from 'react-dom'
import { Router } from 'react-router-dom'
import App from './components/app'
import * as serviceWorker from './services/service-worker'
import reduxStore from './services/redux-store'
import history from './services/history'
import { ConnectedRouter } from 'connected-react-router'
import './index.css'
//import { Modules } from './modules';

ReactDOM.render(
    <Provider store={reduxStore}>
        <ConnectedRouter history={history}>
            <Router history={history}>
                <App />
            </Router>
        </ConnectedRouter>
    </Provider>

    , document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();